export interface PropertiesWithProject {
	DeveloperNameAr?: string;
	DeveloperNameEn?: string;
	DeveloperNumber?: number;
	Identity?: number;
	PercentCompleted?: number;
	ProjectId?: number;
	ProjectNameAr?: string;
	ProjectNameEn?: string;
	ProjectNumber?: number;
	ProjectPropCount?: number;
	ThumbnailUrl?: string;
	Url?: string;
	RowValue?: string;
}

export interface ProjectProperty {
	BuildingEjariPropId?: number;
	BuildingNameAr?: string;
	BuildingNameEn?: string;
	BuildingPropertyId?: number;
	BuildingPropertyIdKey?: string;
	BuildingUnitsCount?: number;
	EjariSubTypeNameAr?: string;
	EjariSubTypeNameEn?: string;
	EjariTypeId?: number;
	EjariTypeNameAr?: string;
	EjariTypeNameEn?: string;
	IsRented?: boolean;
	IsFreeHold?: boolean;
	IsManaged?: boolean;
	LandAreaNameAr?: string;
	LandAreaNameEn?: string;
	LandAreaId?: number;
	Latitude?: number;
	Longitude?: number;
	LandPropertyId?: number;
	LandPropertyIdKey?: string;
	MoreData?: boolean;
	PropertyId?: number;
	PropertyIdKey?: string;
	PropertyNumber?: number;
	PropertyTypeId?: number;
	Rooms?: number;
	TotalPropertiesCount?: number;
	TotalRecords?: number;
	UnitPropertyId?: number;
	UnitPropertyIdKey?: string;
	VillaPropertyIdKey?: string;
	IsBlocked?: boolean;
	VillaEjariPropId?: number;
	VillaPropertyId?: number;
	TotalRentAmount?: number;
	RentAmount?: number;
	LandDmNo?: number;
	LandDmSubNo?: number;
	RowValue?: string;
}

export enum RentalStatus {
	ALL = 0,
	RENTED = 5,
	VACANT = 1,
}
